// extracted by mini-css-extract-plugin
module.exports = {"containerBox":"style_containerBox__2lUpd","rowBox":"style_rowBox__1BBXt","textBox":"style_textBox__N-HwL","iconsBox":"style_iconsBox__1xaFp"};